import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-edit-cell-renderer',
    template: `
    <mat-icon
      [matTooltip]="isSubmitted ? 'View' : 'Edit'"
      class="matIcons dcg-edit-icon"
      [svgIcon]="isSubmitted ? 'view_circle' : 'edit_circle'"
    ></mat-icon>
  `,
    styles: [`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      cursor: pointer;
    }
    .dcg-edit-icon {
      width: 30px;
      height: 30px;
      font-size: 20px;
      color: #9CA3AF;
      transition: color 0.15s;
    }
    :host:hover .dcg-edit-icon {
      color: #1363DF;
    }
  `],
    standalone: false
})
export class EditCellRendererComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  // Submitted records (status 103) show a view icon instead of the edit icon.
  get isSubmitted(): boolean {
    return Number(this.params?.data?.statusCode) === 103;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
